import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import GetAppIcon from '@material-ui/icons/GetApp';
import colors from 'config/colors';
import { showCustomBillReceiptService } from 'actions/admin/billing';
import { showToast } from 'actions/admin/auth';
import { getGlobalSchoolUtils } from 'utils/commonFunc';

const linkStyle = { display: 'inline-flex', alignItems: 'center', gap: 3, cursor: 'pointer', color: colors.accent };

// View / Download of a custom bill's receipt, for every list that shows custom bills. Only a paid bill has a receipt; any other
// status is shown as text instead. `billId` is the studentCustomBillId, `label` names the receipt (heading and file name).
const BillReceiptLinks = ({ billId, status, schoolId, label }) => {
  const dispatch = useDispatch();
  const token = useSelector(state => state.auth.loggedUserToken);
  const [loading, setLoading] = useState(false);

  if (!billId) return '--';
  if (status && status !== 'PAID') return <small>{status}</small>;
  if (loading) return <CircularProgress size={15} />;

  const open = download => {
    setLoading(true);
    dispatch(
      showCustomBillReceiptService({
        schoolId: schoolId || getGlobalSchoolUtils()?.schoolId,
        billId,
        label: label || `CB000${billId}`,
        download,
        token,
      })
    )
      .catch(err => dispatch(showToast(err.message, 'error')))
      .finally(() => setLoading(false));
  };

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      <span onClick={() => open(false)} style={linkStyle} title="View receipt">
        <VisibilityIcon style={{ fontSize: 16 }} />
        <b>View</b>
      </span>
      <span className="mx-2" style={{ color: '#c5cad3' }}>
        |
      </span>
      <span onClick={() => open(true)} style={linkStyle} title="Download receipt">
        <GetAppIcon style={{ fontSize: 16 }} />
        <b>Download</b>
      </span>
    </span>
  );
};

export default BillReceiptLinks;
